import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./rg-theme.css";

/**
 * GestionLayout — enveloppe de toutes les pages /admin/gestion/*.
 * Applique la palette "Organic & Earthy" isolée via .rg-scope.
 * Header commun + tabs de navigation.
 */
export default function GestionLayout() {
  const nav = useNavigate();
  return (
    <div className="rg-scope" data-testid="gestion-layout">
      <div className="rg-topbar">
        <button
          type="button"
          onClick={() => nav("/admin")}
          data-testid="rg-back-hub"
          style={{ background: "transparent", border: 0, cursor: "pointer", display: "flex", alignItems: "center", color: "var(--rg-text-2)" }}
          aria-label="Retour Hub"
        >
          <ArrowLeft size={16} />
        </button>
        <h1>Refuge Guests</h1>
        <nav className="rg-nav" style={{ marginLeft: "auto" }}>
          <NavLink to="/admin/gestion/today" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-today">Aujourd&apos;hui</NavLink>
          <NavLink to="/admin/gestion/finances" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-finances">Finances</NavLink>
          <NavLink to="/admin/gestion/calendrier" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-calendar" end>Calendrier</NavLink>
          <NavLink to="/admin/gestion/parcours" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-dashboard">Parcours</NavLink>
          <NavLink to="/admin/gestion/voyageurs" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-guests">Voyageurs</NavLink>
          <NavLink to="/admin/gestion/reglages" className={({isActive}) => isActive ? "active" : ""} data-testid="rg-tab-settings">Réglages</NavLink>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
